var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
// eslint-disable-next-line import/no-extraneous-dependencies
import { Transition } from '@headlessui/react';
import clsx from 'clsx';
// eslint-disable-next-line import/no-extraneous-dependencies
import { nanoid } from 'nanoid';
// eslint-disable-next-line import/no-extraneous-dependencies
import { useEffect, useState } from 'react';
import Dropzone from 'react-dropzone';
import { AiOutlineArrowDown } from 'react-icons/ai';
import { FaFileMedicalAlt, FaFileUpload, FaRegFileImage, FaRegFilePdf } from 'react-icons/fa';
import { attachmentsKeys } from '../../../hooks/attachments/attachments.keys';
import { getAttachments, getEventPresignedAttachment, useDeleteAttachment, useUpdateAttachment, } from '../../../hooks/attachments/useAttachments';
import { useHydrateStore } from '../../../hooks/common/useHydrateForm';
import Button from '../../FormControls/Button';
import { acceptedFileTypes } from './accepted';
import AttachmentItem from './AttachmentItem';
var AttachmentsForm = function (_a) {
    var setValue = _a.setValue, formAttachments = _a.formAttachments, schema = _a.schema, _b = _a.identifierKey, identifierKey = _b === void 0 ? 'eventId' : _b, _c = _a.identifierValue, identifierValue = _c === void 0 ? '' : _c, _d = _a.isInputRequest, isInputRequest = _d === void 0 ? false : _d, specialtyInputResponseId = _a.specialtyInputResponseId, _e = _a.readOnly, readOnly = _e === void 0 ? false : _e, emptyText = _a.emptyText, queryParameters = _a.queryParameters, _f = _a.attachmentEventType, attachmentEventType = _f === void 0 ? 'Conference' : _f, bottomText = _a.bottomText;
    var eventId = queryParameters.get(identifierKey) || identifierValue;
    var _g = useState(false), isDraggingOverDocument = _g[0], setIsDraggingOverDocument = _g[1];
    var _h = useState([]), fileList = _h[0], setFileList = _h[1];
    var _j = useState(null), activeId = _j[0], setActiveId = _j[1];
    var removeAttachmentMutation = useDeleteAttachment();
    var updateAttachmentMutation = useUpdateAttachment();
    var isLoading = useHydrateStore({
        apiCall: function () { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, readOnly
                        ? getEventPresignedAttachment(eventId, attachmentEventType)
                        : getAttachments(eventId, attachmentEventType)];
            });
        }); },
        keys: { cacheKey: attachmentsKeys.list(eventId), formKey: 'attachments' },
        updateStore: setValue,
        shouldRun: Boolean(eventId) &&
            (!formAttachments || (formAttachments && formAttachments.length === 0)) &&
            !isInputRequest,
    }).isLoading;
    useEffect(function () {
        if (formAttachments) {
            setFileList(formAttachments);
        }
    }, [formAttachments]);
    // Drag events only cover dragging over the drop zone, so if we want to display any message while they are dragging
    // in general, we need to target higher up in the chain
    useEffect(function () {
        var setIsDraggingOver = function () {
            setIsDraggingOverDocument(true);
        };
        var setNotDraggingOver = function (event) {
            if (event.relatedTarget === null) {
                setIsDraggingOverDocument(false);
            }
        };
        var setDragFinished = function () {
            setIsDraggingOverDocument(false);
        };
        document.body.addEventListener('dragenter', setIsDraggingOver);
        document.body.addEventListener('dragleave', setNotDraggingOver);
        document.body.addEventListener('drop', setDragFinished);
        return function () {
            document.body.removeEventListener('dragenter', setIsDraggingOver);
            document.body.removeEventListener('dragleave', setNotDraggingOver);
            document.body.removeEventListener('drop', setDragFinished);
        };
    }, []);
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    var onDrop = function (acceptedFiles, rejectedFiles) {
        var acceptedFilesWithoutDuplicates = acceptedFiles
            .filter(function (file) {
            return !fileList.some(function (existingFile) { var _a; return ((_a = existingFile.file) === null || _a === void 0 ? void 0 : _a.name) === file.name || existingFile.fileName === file.name; });
        })
            .map(function (file, index) { return ({
            id: nanoid(),
            fileName: file.name,
            file: file,
            sortOrder: index + fileList.length,
            isUploading: true,
        }); });
        setFileList(function (files) { return __spreadArray(__spreadArray([], files, true), acceptedFilesWithoutDuplicates, true); });
    };
    var onUploadFinished = function (oldId, result) {
        // @TODO: need to consolidate this
        // this is updating two states with the same data
        // the internal component state "fileList"
        // and the form state "setValue"
        // which causes several errors in the js console
        // updating state while rendering...
        setFileList(function (items) {
            var updated = items.map(function (item) {
                return item.id === oldId
                    ? __assign(__assign(__assign({}, item), result), { isUploading: false, file: undefined }) : item;
            });
            setValue('attachments', updated);
            setActiveId(result && result.id ? result.id : oldId);
            return updated;
        });
    };
    var onUploadRestart = function (id) {
        setFileList(function (items) {
            return items.map(function (item) { return (item.id === id ? __assign(__assign({}, item), { isUploading: true }) : item); });
        });
    };
    var onDeleteAttachment = function (id) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            return [2 /*return*/, removeAttachmentMutation.mutateAsync(id).then(function (result) {
                    setFileList(function (files) {
                        var updated = files.filter(function (file) { return file.id !== id; });
                        setValue('attachments', updated);
                        return updated;
                    });
                })];
        });
    }); };
    var onUpdateMetadata = function (id, data) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, updateAttachmentMutation.mutateAsync({ id: id, data: data }).then(function (result) {
                    setFileList(function (files) {
                        var updated = files.map(function (file) { return (file.id === id ? __assign(__assign({}, file), data) : file); });
                        setValue('attachments', updated);
                        return updated;
                    });
                    return result;
                })];
        });
    }); };
    return eventId ? (_jsxs(_Fragment, { children: [readOnly && !isLoading && !formAttachments.length ? (_jsx(_Fragment, { children: _jsx("p", { className: "w-full mx-3 text-sm", "data-cy": "attachments-form-empty", "data-public": "true", children: emptyText || "You don't have any attachments yet." }) })) : null, !readOnly && (_jsx(Dropzone, { noClick: true, onDrop: onDrop, disabled: fileList.some(function (x) { return x.isUploading; }), maxSize: 250000000, accept: acceptedFileTypes, children: function (_a) {
                    var getRootProps = _a.getRootProps, getInputProps = _a.getInputProps, open = _a.open, isDraggingOverDropzone = _a.isDragActive;
                    return (_jsxs("div", __assign({}, getRootProps({
                        className: clsx('p-8 overflow-hidden w-full p-8 text-gray-700 transition-all duration-200 bg-white border-2 border-gray-300 border-dashed rounded-md mb-3', isDraggingOverDropzone && 'border-oncolensBlue-400'),
                    }), { "data-cy": "attachments-form", "data-public": "true", children: [_jsx("input", __assign({}, getInputProps({
                                className: 'hidden',
                            }))), _jsxs("div", { className: "relative h-36 sm:h-32", "data-public": "true", children: [_jsxs(Transition, { show: isDraggingOverDocument, className: "absolute top-0 left-0 flex flex-wrap items-center justify-center w-full h-full transition-all duration-200 transform", enterTo: "opacity-100 translate-y-0", enterFrom: "opacity-0 translate-y-4", leaveTo: "opacity-0 translate-y-4", leaveFrom: "opacity-100 translate-y-0", children: [_jsx(AiOutlineArrowDown, { className: "mr-2 text-3xl text-gray-600 animate-bounce" }), _jsx("h3", { className: "text-xl", children: "Drop files here" })] }), _jsxs(Transition, { show: !isDraggingOverDocument, className: "absolute top-0 left-0 flex flex-wrap items-center justify-center w-full h-full transition-all duration-200 transform", enterTo: "opacity-100 translate-y-0", enterFrom: "opacity-0 -translate-y-4", leaveTo: "opacity-0 -translate-y-4", leaveFrom: "opacity-100 translate-y-0", children: [_jsxs("div", { className: "flex items-center justify-center mb-1 text-gray-600 ", "data-public": "true", children: [_jsx(Transition.Child, { className: "transition-all transform", enterTo: "rotate-0 translate-x-0", enterFrom: "-rotate-6 -translate-x-2", leaveFrom: "rotate-0 translate-x-0", leaveTo: "-rotate-6 -translate-x-2", children: _jsx(FaRegFileImage, { className: "text-4xl" }) }), _jsx(Transition.Child, { className: "transition-all transform", enterTo: "translate-y-0", enterFrom: "-translate-y-2", leaveFrom: "translate-y-0", leaveTo: "-translate-y-2", children: _jsx(FaFileMedicalAlt, { className: "-ml-3 text-4xl bg-white rounded-md" }) }), _jsx(Transition.Child, { className: "transition-all transform", enterTo: "rotate-0 translate-x-0", enterFrom: "rotate-6 translate-x-2", leaveFrom: "rotate-0 translate-x-0", leaveTo: "rotate-6 translate-x-2", children: _jsx(FaRegFilePdf, { className: "-ml-3 text-4xl bg-white rounded-md" }) })] }), _jsxs("div", { className: "w-full mt-2", "data-public": "true", children: [_jsx("h3", { className: "w-full mb-1 text-lg text-center", "data-public": "true", children: "Drag and drop files here to upload" }), _jsxs("h4", { className: "flex items-center justify-center text-base flex-nowrap", "data-public": "true", children: ["or", _jsxs(Button, { type: "button", buttonColor: "blue", className: "inline-flex items-center justify-center w-24 py-1 ml-2", onClick: open, testSelector: "attachments-form-browse-button", children: [_jsx(FaFileUpload, { className: "mr-2" }), " Browse"] })] }), bottomText && (_jsx("h5", { className: "mt-2 text-sm text-center text-gray-400 ", "data-public": "true", children: bottomText }))] })] }), _jsx(Transition, { show: fileList.some(function (x) { return x.isUploading; }), className: 'absolute left-0 top-0 w-full h-full bg-white z-10 opacity-0 transition-opacity', enterFrom: "opacity-0", enterTo: "opacity-40", entered: "opacity-40", leaveTo: "opacity-0", leaveFrom: "opacity-40" })] })] })));
                } })), fileList.map(function (item) { return (_jsx(AttachmentItem, { data: item, eventId: eventId, attachmentSchema: schema, specialtyInputResponseId: specialtyInputResponseId, onUploadFinished: onUploadFinished, onUploadRestart: onUploadRestart, onDeleteAttachment: onDeleteAttachment, onUpdateMetadata: onUpdateMetadata, activeId: activeId, setActiveId: setActiveId, readOnly: readOnly, attachmentEventType: attachmentEventType }, item.fileName)); })] })) : (_jsx("div", { className: "flex items-center justify-center p-8", children: _jsx("p", { children: "Attachments can only be added once the form is saved. Please save the form first to add attachments." }) }));
};
export { AttachmentsForm as default };
